<template>
  <div class="c-select-product">
    <div
      v-for="lineItem in lineItems"
      :key="lineItem.id"
      class="c-select-product__product"
    >
      <SelectProductCard
        :line-item="lineItem"
        @checkboxChanged="CheckboxChanged"
      />
    </div>
  </div>
</template>
<script>
import SelectProductCard from "@/components/selectProduct/SelectProductCard";
export default {
  name:"SelectProduct",
  components: {
    SelectProductCard,
  },
  props: {
    lineItems: {
      type: Array,
      default: ()=>[]
    }
  },
  methods: {
    CheckboxChanged(data) {
      this.$emit("checkboxChanged", data)
    }
  }

}
</script>
<style lang="scss" scoped>
.c-select-product {
  &__product {
    @include themify($themes) {
      border-bottom: rem(3px) solid themed('foreground', 'select');
      //border-color: ;
    }

    &:last-of-type {
      border-bottom: none;
    }
  }

}
</style>